<template>
    <div class="table">
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校" @change="getData()">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAdd({},1)">新增</el-button>
            </div>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border
                :tree-props="{children: 'children'}">
                <el-table-column type="index" label="序号" fixed width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="text" label="名称"  fixed  :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="attributes.value" label="值（分）"  :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="attributes.orderNum" label="排序号" width="80"></el-table-column>
                <el-table-column fixed="right" label="操作" width="110px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.attributes.value ==null "
                            @click.native.prevent="setAdd(scope.row,2)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">新增</span>
                        </el-button>
                        <el-button  @click.native.prevent="setUpdate(scope.row,scope.row.attributes.value ==null?1:2)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http'; 
    import add from './AddRewardType.vue';
    import update from './UpdateRewardType.vue';

    export default {
        data(){
            return{
                loading:false,
                addVisible:false,
                updateVisible:false,
                form:{
                    deptId:"",
                },
                data:[],
                depts:[]
            }
        },
        components: {
            add,update
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                let url  = this.teacherAssessBaseTypeTreeListUrl;
                let data = {
                    deptId:this.form.deptId,
                    type:2
                };
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data));
                    if(res.status==200){
                       this.data = res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            //新增界面
            setAdd(data,sign){
                this.addVisible=true;
                // 父级新增
                if(sign == 1){
                    data.deptId=this.form.deptId;
                }else if(sign == 2){
                    data.parentId=data.id;
                }
                this.$nextTick(() => {
                    this.$refs['add'].init(data,sign);
                })
            },
            //修改界面
            setUpdate(data,sign){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data,sign);
                })
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.teacherAssessBaseTypeRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/basis/RewardType.vue